import { Link } from "react-router-dom";

export default function Section2() {
  const list = [
    "High traffic but low sales or leads",
    "High cart abandonment or form drop-offs",
    "Users visiting key pages but not converting",
    "Poor mobile performance for UAE users",
    "Confusing navigation or unclear calls to action",
  ];

  return (
    <div className="Section2 bg-[#F5F5F5] py-[35px]">
      <div className="section2-container mx-auto w-full px-[15px] md:w-[750px] lg:w-[970px] xl:w-[1170px]">
        <div className=" bg-white lg:flex rounded-[3px] shadow-[0_1px_2px_rgba(0,0,0,.1)]">
          <div className="lg:w-1/2 lg:pr-[15px]">
            <div className="p-[10px_50px_45px] md:p-[30px_20px_45px_50px] lg:p-[10px_0_25px_30px] ">
              <h2 className="text-[24px] md:text-[34px] font-bold my-[0.67em] text-[#DA2128] leading-[32px] md:leading-[40px]">
                Is Your UAE Website Losing Potential Customers?
              </h2>

              <p className="text-[16px] font-open text-[#535353] mt-10 lg:mt-0 mb-5">
                If you get traffic but no results, your website may need CRO. Here are the signs:

              </p>

              <ul className="my-[25px]">
                {list.map((item, index) => {
                  return item === "Search Engine Optimization" ? (
                    <li
                      className="bg-[url('/public/assets/tick-image-social-media-marketing.jpg')] bg-left-center bg-no-repeat pl-[50px]"
                      key={index}
                    >
                      <h4 className="mb-[5px] font-[600] uppercase text-[14px] leading-[1.3] font-open hover:text-[#cd2122]">
                        <Link to="/seo">{item}</Link>
                      </h4>
                    </li>
                  ) : (
                    <li
                      key={index}
                      className="bg-[url('/public/assets/tick-image-social-media-marketing.jpg')] bg-left-center bg-no-repeat pl-[50px]"
                    >
                      <h4 className="mb-[5px] mt-5 font-[600] uppercase text-[#323232] text-[14px] leading-[1.3] font-open">
                        {item}
                      </h4>
                    </li>
                  );
                })}
              </ul>

              <p className="text-[16px] font-open text-[#535353] mt-10 lg:mt-0 mb-5">
                If this sounds familiar, your website has untapped potential, and Mean3 can help unlock it.

              </p>


            </div>
          </div>

          <div className="lg:w-1/2 lg:pl-[15px]">
            <div className="relative bg-[#dcdee7] p-[36px_0_0] rounded-tr-[4px] rounded-tl-[4px] before:absolute before:block before:content-[''] before:top-[15px] before:left-[30px] before:bg-[#ababab] before:rounded-[50%] before:w-[7px] before:h-[7px] before:shadow-[-12px_0_0_#ababab,12px_0_0_#ababab]">
              <img
                src="/assets/search-engine-social-media-marketing.jpg"
                alt="Digital Marketing"
              ></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
